module.exports = __webpack_public_path__ + "static/media/loginBG.97ebbaf1.jpg";